import React from 'react';
import Box from '@mui/material/Box';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import PageTitle from '@/components/PageTitle/PageTitle';
import useBreadcrumbs from '@/hooks/useBreadcrumbs';
import tokens from '@/core/tokens.json';
import { useTablet } from '@/hooks/responsiveHooks';

type TopBarModes = 'shrunk' | 'blank' | 'breadcrumbs';

interface TopBarProps {
  crumb?: React.ReactNode;
}

function TopBar({ crumb: crumbComponent }: TopBarProps) {
  const isTablet = useTablet();
  const crumbs = useBreadcrumbs();

  const areCrumbs = crumbs.length > 1 || crumbComponent !== undefined;
  const mode: TopBarModes = !areCrumbs ? (isTablet ? 'shrunk' : 'blank') : 'breadcrumbs';
  const mb = mode === 'shrunk' ? 29.25 : 2;
  const pt = mode === 'shrunk' ? 6 : 5;

  const getChildren = {
    breadcrumbs: crumbComponent ? crumbComponent : <Breadcrumbs />,
    shrunk: (
      <header>
        <PageTitle variant="minimal">{tokens.APP_TITLE_SHRUNK}</PageTitle>
      </header>
    ),
    blank: <></>,
    default: <></>,
  };

  return (
    <Box
      className="crumbs-alert"
      pt={pt}
      pb={5}
      mb={mb}
      minHeight={mode === 'blank' ? '64px' : 'auto'}
    >
      {getChildren[mode]}
    </Box>
  );
}

export default TopBar;
